/**
 * ¿ESTE FICHERO ES UNA FOTO? (ALT-11, 14-10)
 *
 * En el alta, un texto llamado `no-es-foto.jpg` se quedaba puesto como «la tuya», con una
 * imagen rota y el botón de quitarla: el cliente creía que su foto estaba subida. El nombre
 * y el tipo que declara el fichero no demuestran nada; se miran sus primeros bytes.
 *
 * Es la misma regla que `parece_una_imagen` de `backend/core/fotos.py` (JPEG, PNG, WebP y
 * la familia HEIC), y por lo mismo NO se intenta abrir la imagen: un HEIC de iPhone no se
 * abre en todos los navegadores y no por eso deja de ser una foto.
 */
export const NO_ES_UNA_FOTO = 'Eso no es una foto. Elige una imagen de tu galería.';

const HEIC = ['heic', 'heix', 'hevc', 'hevx', 'heim', 'heis', 'mif1', 'msf1', 'avif'];
const texto = (bytes, desde, hasta) => String.fromCharCode(...bytes.slice(desde, hasta));

/** Sobre los primeros bytes del fichero (con 12 basta). */
export const empiezaComoUnaImagen = (bytes) => {
    const c = Array.from(bytes || []);
    if (c[0] === 0xff && c[1] === 0xd8 && c[2] === 0xff) return true;                  // JPEG
    if (texto(c, 1, 4) === 'PNG' && c[0] === 0x89) return true;                        // PNG
    if (texto(c, 0, 4) === 'RIFF' && texto(c, 8, 12) === 'WEBP') return true;          // WebP
    return texto(c, 4, 8) === 'ftyp' && HEIC.includes(texto(c, 8, 12));                // HEIC
};

/** Lee el principio del fichero y contesta. Si no se puede leer, no es una foto. */
export const pareceUnaImagen = (file) => new Promise((resolve) => {
    if (!file) { resolve(false); return; }
    const lector = new FileReader();
    lector.onload = () => resolve(empiezaComoUnaImagen(new Uint8Array(lector.result)));
    lector.onerror = () => resolve(false);
    lector.readAsArrayBuffer(file.slice(0, 12));
});
